module.exports = __webpack_public_path__ + "static/media/create-poll.b094682e.svg";